









































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { authModule, challengeModule, teamModule, teamsState, userModule } from '@/utils/store-acessor';
import { InvitationsModel, InvitationStatus, TeamModel } from '@/models/team.model';
import ShareButton from '@/components/Shared/buttons/ShareButton.vue';
import { UserModel } from '@/models/user.model';
import { ChallengeModel } from '@/models/challenge.model';
import { Watch } from 'vue-property-decorator';

@Component({
  components: {
    ShareButton
  }
})
export default class ChallengeTeam extends Vue {
  @userModule.Getter('user') currentUser!: UserModel;
  @teamModule.Getter('selectedTeam') team!: TeamModel;
  @teamModule.Getter('invitesByStatus') members!: (status: InvitationStatus) => InvitationsModel[];
  @teamModule.Getter('isOwner') isOwner!: (
    team: TeamModel,
    user: UserModel
  ) => boolean;
  @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;
  @challengeModule.Getter('selectedChallenge')
  readonly challenge!: ChallengeModel | null;
  @userModule.Getter('canAcceptChallenges') canAccept!: boolean;
  loading = false;
  dialog = false;
  destroyLoading = false;
  snackbarVisibility = false;
  snackbarColor: 'green' | 'red' = 'green';
  snackbarText = '';

  get urlToShare(): string {
    if (this.team?.slug) {
      const host = window.location.host;
      const url = this.$router.resolve({
        name: 'show-team',
        params: {
          teamSlug: this.team?.slug
        }
      }).href;
      return host + url;
    }
    return ''
  }

  get canRequestInvite(): boolean {
    return this.isAuthenticated && this.canAccept && (
      !this.team?.my_invite
      || this.team?.my_invite?.status === 'rejected'
      || this.team?.my_invite?.status === 'removed'
      || this.team?.my_invite?.status === 'canceled'
    );
  }

  get canExitFromTeam(): boolean {
    const alreadyAccepted = this.team?.my_invite?.status === 'accepted';
    return this.isAuthenticated && this.canAccept && alreadyAccepted
  }

  get canCancelInvite(): boolean {
    const alreadySent = this.team?.my_invite?.status === 'pending'
      && this.team?.my_invite?.invitation_mode === 'requested';
    return this.isAuthenticated && this.canAccept && alreadySent
  }

  get getUserInTeam(): InvitationsModel | null {
    if (this.team?.members) {
      const memberIndex = this.members('accepted').findIndex((v) => v.user?.id === this.currentUser?.id);
      if (~memberIndex) {
        return this.team.members[memberIndex]
      }
    }
    return null
  }

  @Watch('$route', { deep: true, immediate: true })
  async beforeRouteEnter() {
    const challengeId = this.challenge?.id;
    const usuarioId = this.currentUser?.id;
    const slug = this.$route.params?.teamSlug;
    if (challengeId && slug) {
      await teamsState.fetchTeamBySlug({ challengeId, slug });
      return await this.fetchPendingInvites(slug, challengeId)
    } else if (challengeId) {
      if (usuarioId) {
        const team = await teamsState.fetchMyTeam(challengeId, usuarioId);
        if (team.slug) {
          return await this.fetchPendingInvites(team.slug, challengeId)
        }
      }
    }
  }

  async sendInvite() {
    this.loading = false;
    if (!this.team?.id || !this.team?.challenge_id) {
      return;
    }
    this.loading = true;
    try {
      this.team.my_invite = await teamsState.sendInvitation({
        teamId: this.team.id,
        challengeId: this.team.challenge_id
      });
      this.snackbarMessage('invites.messages.send.success', 'green');
    } catch (e) {
      this.snackbarMessage('invites.messages.send.failed', 'red');
    } finally {
      this.loading = false;
    }
  }

  async onDestroy() {
    this.dialog = false;
    if (this.team?.id && this.team?.challenge_id) {
      this.destroyLoading = true;
      try {
        await teamsState.deleteTeam({
          challengeId: this.team.challenge_id,
          teamId: this.team.id
        });
        this.snackbarMessage('team.messages.destroy.success', 'green');
        this.$router.replace({
          path: `/challenges/${this.$route.params.slug}/`
        });
      } catch (e) {
        this.snackbarMessage('team.messages.destroy.failed', 'red');
      } finally {
        this.destroyLoading = false;
      }
    }
  }

  onEdit() {
    if (this.team?.slug) {
      this.$router.push({
        name: 'edit-challenge-team',
        params: { teamSlug: this.team.slug.toString() }
      });
    }
  }

  inviteUsers() {
    this.$router.push({ name: 'invite-user-to-team' });
  }

  showMembers() {
    const { slug, teamSlug } = this.$route.params;
    if (slug && teamSlug) {
      this.$router.replace({ path: `/challenges/${slug}/teams/${teamSlug}/members` });
    } else if (slug) {
      this.$router.replace({ path: `/challenges/${slug}/teams/my/members` });
    }
  }

  async exitFromTeam() {
    const invite = this.getUserInTeam;
    const teamId = this.team?.id;
    const challengeId = this.challenge?.id;
    if (teamId && challengeId && invite?.id) {
      try {
        await teamsState.leaveTeam({
          inviteId: invite.id,
          teamId,
          challengeId,
        });
        this.snackbarMessage('team.messages.exit.success', 'green');
      } catch (e) {
        this.snackbarMessage('team.messages.exit.failed', 'red');
      }
    }
  }

  async cancelInvite() {
    const invite = this.team?.my_invite;
    this.snackbarVisibility = false;
    const teamId = this.team?.id;
    const challengeId = this.challenge?.id;
    if (teamId && challengeId && invite?.id) {
      try {
        this.loading = true;
        await teamsState.leaveTeam({
          inviteId: invite.id,
          teamId,
          challengeId,
        });
        this.team!.my_invite = undefined;
        this.loading = false;
        this.snackbarMessage('invites.messages.canceled.success', 'green');
      } catch (e) {
        this.loading = false;
        this.snackbarMessage('invites.messages.canceled.failed', 'red');
      }
    }
  }

  showPendentInvitations() {
    this.$router.push({ name: 'team-invitations-pendent' });
  }

  private snackbarMessage(message: string, color: 'green' | 'red') {
    this.snackbarColor = color;
    this.snackbarText = message;
    this.snackbarVisibility = true;
  }

  private async fetchPendingInvites(teamSlug: string, challengeId: number) {
    if (this.isAuthenticated) {
      return await teamsState.fetchPendingInvites({
        slug: teamSlug,
        challengeId: challengeId
      });
    }
  }

}
